const COMPONENT_NAME = 'ReminderPage';

export default function ReminderPage() {
  return <div>{COMPONENT_NAME}</div>;
}
